// Shared invoicing utilities — Alegra API wrappers + CFDI helpers.
// Extracted from InvoiceModal.js so both the single-reservation modal and the
// multi-reservation /invoicing/create page use the same logic.
//
// Public exports:
//   constants: API_URL, API_TOKEN, CHARGE_TYPE_ALEGRA,
//              SAT_TO_ALEGRA_REGIME_12, SAT_TO_ALEGRA_REGIME_13,
//              CFDI_USE_OPTIONS, REGIMEN_OPTIONS,
//              PAYMENT_FORM_OPTIONS, PAYMENT_TYPE_OPTIONS
//   helpers  : getAlegraRegime(satCode, rfc)
//              alegraRequest(endpoint, method, body)
//              findOrCreateContact(billing)
//              saveBillingSettings(billing, { customerId, companyId })
//              buildAlegraItems(items, { periodFrom, periodTo, invoiceNotes })
//              applyRoundingAdjustment(alegraItems, expectedTotal)
//              prefillBillingFromEntity(entity, isCompany)
//              buildInvoicePayload({ billing, alegraItems, contactId, stamp })
//              invoiceDue(inv) — total − amount_paid − amount_credited
//              invoiceCreditable(inv) — total − amount_credited
//              issueCreditNote({ invoice, amount, description, reason,
//                                discountsReservation })
//              cancelCreditNote({ note, motivo, reason })

import supabase from "../supabase-client";

export const API_URL = "https://api.gomoverent.com/v2/alegra/proxy.php";
export const API_TOKEN =
  "h8ISmsSIwTvfl8Tny2nr0dFh2nz3rmiCzBMjtCJOJqn7TF6Y4wnch7uI1FI3ArlZP0wfMsGkEuqNXUzaX9wYSL5bnn9CzB1DkWAMFQVCBWBhRwAXn29M96YYxcp1bmfN";

// Alegra has different regime keys for 12-char RFC (moral) vs 13-char RFC (física)
export const SAT_TO_ALEGRA_REGIME_12 = {
  "601": "GENERAL_REGIME_OF_MORAL_PEOPLE_LAW",
  "603": "REGIME_OF_MORAL_PEOPLE_NOT_PROFIT",
  "620": "REGIME_OF_COOPERATIVE_PRODUCTION_SOCIETIES",
  "622": "PRIMARY_SECTOR_REGIME",
  "623": "SOCIETIES_OPTIONAL_REGIME",
  "624": "REGIME_OF_THE_COORDINATED",
  "625": "REGIME_OF_TRUST",
  "626": "REGIME_OF_TRUST",
  "616": "SIMPLIFIED_REGIME",
};
export const SAT_TO_ALEGRA_REGIME_13 = {
  "605": "SALARIED_REGIME",
  "606": "LEASEHOLD_REGIME",
  "608": "SALARIED_REGIME",
  "611": "DIVIDEND_INCOME",
  "612": "BUSINESS_ACTIVITIES_REGIME",
  "614": "SALARIED_REGIME",
  "616": "SIMPLIFIED_REGIME",
  "621": "FISCAL_INCORPORATION_REGIME",
  "625": "REGIME_OF_THE_TECHNOLOGICAL_PLATFORMS_INCOME_ACTIVITIES",
  "626": "REGIME_OF_TRUST",
};
export const getAlegraRegime = (satCode, rfc) => {
  if (!satCode) return "SIMPLIFIED_REGIME";
  const map = rfc && rfc.length === 12 ? SAT_TO_ALEGRA_REGIME_12 : SAT_TO_ALEGRA_REGIME_13;
  return map[satCode] || "SIMPLIFIED_REGIME";
};

export const CFDI_USE_OPTIONS = [
  { label: "G01 — Adquisición de mercancías", value: "G01" },
  { label: "G02 — Devoluciones, descuentos o bonificaciones", value: "G02" },
  { label: "G03 — Gastos en general", value: "G03" },
  { label: "I01 — Construcciones", value: "I01" },
  { label: "I02 — Mobiliario y equipo de oficina", value: "I02" },
  { label: "I03 — Equipo de transporte", value: "I03" },
  { label: "I04 — Equipo de cómputo y accesorios", value: "I04" },
  { label: "I05 — Dados, troqueles, moldes", value: "I05" },
  { label: "I06 — Comunicaciones telefónicas", value: "I06" },
  { label: "I07 — Comunicaciones satelitales", value: "I07" },
  { label: "I08 — Otra maquinaria y equipo", value: "I08" },
  { label: "D01 — Honorarios médicos y gastos hospitalarios", value: "D01" },
  { label: "D02 — Gastos médicos por incapacidad", value: "D02" },
  { label: "D03 — Gastos funerales", value: "D03" },
  { label: "D04 — Donativos", value: "D04" },
  { label: "D05 — Intereses por créditos hipotecarios", value: "D05" },
  { label: "D06 — Aportaciones voluntarias al SAR", value: "D06" },
  { label: "D07 — Primas por seguros de gastos médicos", value: "D07" },
  { label: "D08 — Gastos de transportación escolar", value: "D08" },
  { label: "D09 — Depósitos en cuentas para el ahorro", value: "D09" },
  { label: "D10 — Pagos por servicios educativos", value: "D10" },
  { label: "S01 — Sin efectos fiscales", value: "S01" },
  { label: "CP01 — Pagos", value: "CP01" },
  { label: "CN01 — Nómina", value: "CN01" },
];

export const REGIMEN_OPTIONS = [
  { label: "Seleccionar", value: "" },
  { label: "601 — General de Ley Personas Morales", value: "601" },
  { label: "603 — Personas Morales con Fines no Lucrativos", value: "603" },
  { label: "605 — Sueldos y Salarios e Ingresos Asimilados", value: "605" },
  { label: "606 — Arrendamiento", value: "606" },
  { label: "607 — Régimen de Enajenación o Adquisición de Bienes", value: "607" },
  { label: "608 — Demás ingresos", value: "608" },
  { label: "610 — Residentes en el Extranjero sin Establecimiento Permanente", value: "610" },
  { label: "611 — Ingresos por Dividendos (socios y accionistas)", value: "611" },
  { label: "612 — Personas Físicas con Actividades Empresariales y Profesionales", value: "612" },
  { label: "614 — Ingresos por intereses", value: "614" },
  { label: "616 — Sin obligaciones fiscales", value: "616" },
  { label: "620 — Sociedades Cooperativas de Producción", value: "620" },
  { label: "621 — Incorporación Fiscal", value: "621" },
  { label: "622 — Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras", value: "622" },
  { label: "623 — Opcional para Grupos de Sociedades", value: "623" },
  { label: "624 — Coordinados", value: "624" },
  { label: "625 — Régimen de Actividades Empresariales con Plataformas Tecnológicas", value: "625" },
  { label: "626 — Régimen Simplificado de Confianza (RESICO)", value: "626" },
];

export const PAYMENT_FORM_OPTIONS = [
  { label: "01 — Efectivo", value: "cash" },
  { label: "03 — Transferencia electrónica", value: "transfer" },
  { label: "04 — Tarjeta de crédito", value: "credit-card" },
  { label: "28 — Tarjeta de débito", value: "debit-card" },
  { label: "99 — Por definir", value: "other" },
];

export const PAYMENT_TYPE_OPTIONS = [
  { label: "PUE — Pago en una sola exhibición", value: "PUE" },
  { label: "PPD — Pago en parcialidades o diferido", value: "PPD" },
];

export const CHARGE_TYPE_ALEGRA = {
  damage: 275,
  fuel: 276,
  cleaning: 280,
  fine: 277,
  toll: 278,
  other: 279,
};

// Canonical invoice-friendly labels per charge type. Used as the line's
// description (what customer sees as the concept name); the raw user-entered
// `charge.description` goes into the per-line note field for detail.
export const CHARGE_TYPE_LABEL = {
  damage: "Daños al vehículo",
  fuel: "Cuota de recuperación de combustible",
  cleaning: "Servicio de limpieza",
  fine: "Multa de tránsito",
  toll: "Peaje",
  other: "Cargo extra",
};

// ---------- Alegra product resolution ----------
//
// Invoice lines must reuse EXISTING Alegra products. Creating one whenever a line
// had no product id left ~300 duplicates ("Renta de vehículo", "Renta de vehículo
// PLATE - Periodo …", free-text concepts) and split Alegra's product reports.

// One generic product for every sublease rent line (vehicle data goes in the
// line note, see buildSubleaseVehicleLabel).
export const SUBLEASE_RENT_ALEGRA_ITEM_ID = 619;

// Custom fields on car products ("Servicio de Renta de Unidad - PLATE").
export const CAR_PRODUCT_FIELD_IDS = {
  brand: "01JNRMG0SZ7RSKB69XWNJCTAGG",
  model: "01JNRMGPXBNGD992SHE1V1DFZ8",
  vin: "01JNRMJGP2NYNEV4QB5DP7SG4A",
  plate: "01KGNGPNYVPQ006AH4DWEHMBKP",
  year: "01KGR7T3X0GMYMFWYDHC55E5F7",
};

const escapeRegExp = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// A car's own rent product: "Servicio(s) de Renta de Unidad/Vehículo - PLATE".
// Excludes the old per-invoice "… - Periodo X al Y" products.
export function matchesCarProductName(name, plate) {
  if (!name || !plate || /periodo/i.test(name) || !/renta/i.test(name)) return false;
  return new RegExp(`-\\s*${escapeRegExp(plate.trim())}\\s*$`, "i").test(name.trim());
}

// Products a vendor may pick for a manual concept line: active, and not a rent
// product (rent lines are built from the reservation) nor the rounding line.
export function isPickableAlegraProduct(item) {
  if (!item || item.status === "inactive") return false;
  const name = item.name || "";
  if (/^servicios? de renta de (unidad|veh[ií]culo)/i.test(name)) return false;
  if (/^renta de veh[ií]culo/i.test(name)) return false;
  return Number(item.id) !== 273;
}

// Resolve the Alegra product for an owned car's rent line: the car's linked
// product, else an existing product for its plate, else create it ONCE (with
// Marca/Modelo/Serie/Placa/Año) — and link it on the car so it is reused.
export async function ensureCarAlegraItem(reservationId) {
  const { data: res, error } = await supabase
    .from("reservations")
    .select("car(id, plate, vin, year, alegra_item_id, model(name, brand(name)))")
    .eq("id", reservationId)
    .maybeSingle();
  const car = res?.car;
  if (error || !car) {
    throw new Error(`No se encontró la unidad de la reserva ${reservationId} para facturar la renta.`);
  }
  if (car.alegra_item_id) return car.alegra_item_id;
  const plate = (car.plate || "").trim();
  if (!plate) throw new Error(`La unidad de la reserva ${reservationId} no tiene placa; no se puede facturar la renta.`);

  let itemId = null;
  const found = await alegraRequest(`items?query=${encodeURIComponent(plate)}`, "GET");
  const match = (Array.isArray(found) ? found : []).find(
    (i) => i.status !== "inactive" && matchesCarProductName(i.name, plate)
  );
  if (match) {
    itemId = match.id;
  } else {
    const f = CAR_PRODUCT_FIELD_IDS;
    const customFields = [
      [f.brand, car.model?.brand?.name],
      [f.model, car.model?.name],
      [f.vin, car.vin],
      [f.plate, plate],
      [f.year, car.year],
    ]
      .filter(([, v]) => v != null && v !== "")
      .map(([id, value]) => ({ id, value }));
    const created = await alegraRequest("items", "POST", {
      name: `Servicio de Renta de Unidad - ${plate}`,
      type: "service",
      productKey: "78111808",
      price: 0,
      inventory: { unit: "DAY" },
      tax: [{ id: 2 }], // IVA 16%, like the existing car products
      customFields,
    });
    itemId = created?.id;
    if (!itemId) throw new Error(`No se pudo crear el producto de Alegra para ${plate}.`);
  }
  // Best effort: vendors without cars.edit can't write this; the plate search
  // above still finds the product next time, so no duplicate is created.
  await supabase
    .from("cars")
    .update({ alegra_item_id: String(itemId) })
    .eq("id", car.id)
    .is("alegra_item_id", null);
  return itemId;
}

// ---------- Alegra API wrapper ----------

export async function alegraRequest(endpoint, method = "GET", body = null) {
  const res = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${API_TOKEN}`,
    },
    body: JSON.stringify({ endpoint, method, body }),
  });
  const data = await res.json();
  if (!data.success) {
    const errMsg =
      typeof data.error === "object"
        ? data.error.message || JSON.stringify(data.error)
        : data.error || "Alegra API error";
    const err = new Error(errMsg);
    err.alegraResponse = data.alegra_response;
    throw err;
  }
  return data.data;
}

// The folio fiscal of a stamped CFDI, from Alegra's invoice response, or null
// (draft, stamping failed, unexpected shape). Saved into
// invoices_issued.cfdi_uuid at creation, so nothing has to ask Alegra later.
export function cfdiUuidOf(alegraInvoice) {
  const u = String(alegraInvoice?.stamp?.uuid || "").toUpperCase();
  return /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/.test(u) ? u : null;
}

// What a folio still owes: its total minus payments minus notas de crédito.
// Use this instead of `total - amount_paid` anywhere a balance is shown or
// money is allocated — a credited invoice would otherwise read as owed.
export function invoiceDue(inv) {
  return (
    Math.round(
      ((inv?.total || 0) - (inv?.amount_paid || 0) - (inv?.amount_credited || 0)) * 100
    ) / 100
  );
}

// ---------- Notas de crédito (CFDI tipo E) ----------
//
// One credit note relates to exactly ONE invoice (Alegra's rule for México) and
// Alegra only applies it up to what that invoice still owes there. Alegra fills
// in the SAT side itself: TipoRelacion 01, UsoCFDI G02, clave 84111506 / ACT.
//
// Paid invoices: the part of the credit note the balance doesn't cover is first
// taken off the invoice's plain Alegra payments (freeAlegraPayments), and
// register_credit_note frees the same amount from our allocations — it stays
// as unapplied money, the customer's saldo a favor. A stamped complemento de
// pago (REP) is never touched: changing it means cancelling a CFDI.
//
// Order matters the same way it does for invoices: everything that can fail is
// checked BEFORE stamping, because a stamped CFDI is irreversible; the payment
// changes are undone if the stamp fails. After the stamp, register_credit_note
// records it in our books (invoice balance, freed payments and, when
// `discountsReservation`, a reservation_discounts row).

// Most a new credit note can take off an invoice: its total minus earlier ones.
export function invoiceCreditable(inv) {
  return round2((inv?.total || 0) - (inv?.amount_credited || 0));
}

// Take `amount` off the plain (unstamped) Alegra payments applied to one
// invoice, newest first, by deleting each payment and re-creating it smaller —
// the same Alegra calls the payment flows already use. Plans everything before
// changing anything. Returns an async `restore()` that puts them back.
async function freeAlegraPayments(alegraInvoiceId, folio, amount) {
  const detail = await alegraRequest(`invoices/${alegraInvoiceId}?fields=payments`, "GET");
  const listed = [...(detail?.payments || [])].sort(
    (a, b) => String(b.date || "").localeCompare(String(a.date || "")) || Number(b.id) - Number(a.id)
  );

  const plan = [];
  let left = round2(amount);
  let skippedRep = false;
  for (const p of listed) {
    if (left <= 0.005) break;
    const full = await alegraRequest(`payments/${p.id}`, "GET");
    if (full?.stamp?.uuid) {
      skippedRep = true;
      continue;
    }
    const line = (full?.invoices || []).find((i) => String(i.id) === String(alegraInvoiceId));
    const take = round2(Math.min(Number(line?.amount) || 0, left));
    if (take <= 0.005) continue;
    plan.push({ full, take });
    left = round2(left - take);
  }
  if (left > 0.005) {
    throw new Error(
      skippedRep
        ? `${folio} está pagada con un complemento de pago timbrado. La nota de crédito ` +
            `sólo puede llegar hasta lo que la factura debe más sus pagos sin complemento.`
        : `En Alegra los pagos de ${folio} no alcanzan para la nota de crédito. ` +
            `Concilia los pagos de la factura antes de emitirla.`
    );
  }

  const paymentBody = (full, invoices) => ({
    date: full.date,
    bankAccount: full.bankAccount?.id,
    paymentMethod: full.paymentMethod,
    type: "in",
    ...(full.anotation ? { anotation: full.anotation } : {}),
    invoices,
  });
  // Our allocations point at the Alegra payment that registered them.
  const repoint = (fromId, toId) =>
    supabase
      .from("invoice_payment_allocations")
      .update({ alegra_payment_id: toId })
      .eq("alegra_payment_id", String(fromId));

  const done = [];
  const restore = async () => {
    for (const d of [...done].reverse()) {
      try {
        if (d.newId) await alegraRequest(`payments/${d.newId}`, "DELETE");
        const back = await alegraRequest(
          "payments",
          "POST",
          paymentBody(d.full, d.full.invoices.map((i) => ({ id: String(i.id), amount: Number(i.amount) })))
        );
        await repoint(d.newId || d.full.id, String(back.id));
      } catch (e) {
        console.error("No se pudo restaurar el pago de Alegra", d.full.id, e);
      }
    }
  };

  try {
    for (const { full, take } of plan) {
      const lines = full.invoices
        .map((i) => ({
          id: String(i.id),
          amount: String(i.id) === String(alegraInvoiceId) ? round2(Number(i.amount) - take) : Number(i.amount),
        }))
        .filter((i) => i.amount > 0.005);
      await alegraRequest(`payments/${full.id}`, "DELETE");
      const step = { full, newId: null };
      done.push(step);
      if (lines.length) {
        const resp = await alegraRequest("payments", "POST", paymentBody(full, lines));
        step.newId = String(resp.id);
      }
      await repoint(full.id, step.newId);
    }
  } catch (e) {
    await restore();
    throw new Error(`No se pudo ajustar el pago de ${folio} en Alegra: ${e.message}`);
  }
  return restore;
}

export async function issueCreditNote({ invoice, amount, description, reason, discountsReservation }) {
  const total = round2(parseFloat(amount));
  const folio = invoice.invoice_number || `#${invoice.alegra_id}`;
  if (!(total > 0)) throw new Error("Escribe el monto de la nota de crédito.");
  if (total > invoiceCreditable(invoice) + 0.005) {
    throw new Error(
      `A ${folio} sólo se le pueden acreditar ${invoiceCreditable(invoice).toFixed(2)}.`
    );
  }

  // Preflight against Alegra: live invoice, IVA 16% lines, known balance.
  const alegraInv = await alegraRequest(`invoices/${invoice.alegra_id}`, "GET");
  const cancelState = await getAlegraCancelState(invoice.alegra_id);
  if (cancelState) throw new Error(`${folio} está ${cancelState} en Alegra.`);
  const baseItem = (alegraInv?.items || [])[0];
  const hasIva16 = (alegraInv?.items || []).every((it) =>
    (it.tax || []).some((t) => String(t.id) === "2")
  );
  if (!baseItem || !hasIva16) {
    throw new Error(`${folio} tiene conceptos sin IVA 16%; emite esta nota de crédito desde Alegra.`);
  }
  const alegraBalance = parseFloat(alegraInv?.balance);
  if (!Number.isFinite(alegraBalance)) {
    throw new Error(`Alegra no devolvió el saldo de ${folio}. Inténtalo de nuevo.`);
  }

  const items = [
    {
      id: baseItem.id,
      price: Math.round((total / 1.16) * 1000000) / 1000000,
      quantity: 1,
      description: description.trim(),
      tax: [{ id: 2 }],
    },
  ];
  applyRoundingAdjustment(items, total);

  // Paid (or partly paid) in Alegra: make room on its plain payments first.
  const shortfall = round2(total - alegraBalance);
  const restorePayments =
    shortfall > 0.005 ? await freeAlegraPayments(invoice.alegra_id, folio, shortfall) : null;

  const today = new Date().toLocaleDateString("en-CA");
  let creditNote;
  try {
    creditNote = await alegraRequest("credit-notes", "POST", {
      date: today,
      client: { id: String(alegraInv.client?.id) },
      items,
      type: "01",
      invoices: [{ id: String(invoice.alegra_id), amount: total }],
      paymentMethod: "other",
      paymentType: "PUE",
      anotation: (reason || "").trim() || `Nota de crédito sobre factura ${folio}`,
      stamp: { generateStamp: true, version: "4.0" },
    });
  } catch (err) {
    // Stamping failed: Alegra still creates the note (open, unstamped) and
    // applies it to the invoice. Delete it so the invoice balance comes back.
    const draftId = err.alegraResponse?.creditNote?.id;
    if (draftId) {
      try {
        await alegraRequest(`credit-notes/${draftId}`, "DELETE");
      } catch {}
    }
    if (restorePayments) await restorePayments();
    throw err;
  }

  const number = creditNote.numberTemplate?.fullNumber || String(creditNote.id);
  const uuid = cfdiUuidOf(creditNote);
  if (!uuid) {
    try {
      await alegraRequest(`credit-notes/${creditNote.id}`, "DELETE");
    } catch {}
    if (restorePayments) await restorePayments();
    throw new Error("Alegra no timbró la nota de crédito. Inténtalo de nuevo.");
  }

  const { data, error } = await supabase.rpc("register_credit_note", {
    p_invoice_id: invoice.id,
    p_alegra_id: String(creditNote.id),
    p_cfdi_uuid: uuid,
    p_number: number,
    p_date: creditNote.date || today,
    p_subtotal: creditNote.subtotal ?? round2(total / 1.16),
    p_tax: creditNote.tax ?? round2(total - total / 1.16),
    p_total: creditNote.total ?? total,
    p_description: description.trim(),
    p_reason: (reason || "").trim() || null,
    p_discounts_reservation: !!discountsReservation,
  });
  if (error) {
    // The CFDI is live at SAT: re-issuing would credit the invoice twice.
    throw new Error(
      `La nota de crédito ${number} se timbró (UUID ${uuid}), pero no se registró ` +
        `en el sistema: ${error.message}. NO la vuelvas a emitir; avisa a administración.`
    );
  }
  return data;
}

// Cancel a credit note: void it in Alegra (a CFDI de egreso needs no
// acceptance from the receiver), then undo it in our books. One already voided
// from Alegra's web UI is just recorded. Payments freed when it was issued are
// not re-applied: the invoice owes again and that money stays unapplied.
export async function cancelCreditNote({ note, motivo, reason }) {
  const label = `NC ${note.number || note.alegra_id}`;
  const current = await alegraRequest(`credit-notes/${note.alegra_id}`, "GET");
  if (current?.status !== "void") {
    await alegraRequest(`credit-notes/${note.alegra_id}/void`, "POST", { cause: motivo });
  }
  const { data, error } = await supabase.rpc("cancel_credit_note", {
    p_credit_note_id: note.id,
    p_motivo: motivo,
    p_reason: (reason || "").trim() || null,
  });
  if (error) {
    throw new Error(
      `${label} se canceló en Alegra, pero no se registró en el sistema: ` +
        `${error.message}. Avisa a administración.`
    );
  }
  return data;
}

// ---------- Alegra-side cancellation state ----------

// Our DB only learns about a cancellation when it goes through our own flows,
// so an invoice cancelled from Alegra's web UI still reads `open` here. Ask
// Alegra directly before doing anything that assumes the CFDI is still live.
// Returns null when it is live (or a previous cancel was rejected by the
// receiver, so it can be cancelled again), otherwise a short Spanish label.
export async function getAlegraCancelState(alegraInvoiceId) {
  if (!alegraInvoiceId) return null;
  const inv = await alegraRequest(`invoices/${alegraInvoiceId}`, "GET");
  const emission = String(inv?.stamp?.emissionStatus || "").toUpperCase();
  if (inv?.status === "void") return "cancelada";
  if (emission.includes("CANCEL") && !emission.includes("REJECT")) {
    const cause = inv?.voidCause ? ` (motivo ${inv.voidCause})` : "";
    return emission.includes("WAITING")
      ? `con cancelación en proceso${cause}`
      : `cancelada${cause}`;
  }
  return null;
}

// ---------- Detach payments before voiding ----------

// Alegra refuses to void a stamped CFDI that still has payments applied
// ("Tu factura tiene pagos asociados"), so every cancellation path — plain
// cancel AND substitution/re-facturación — must clear them first. The money is
// not lost: the DB side (cancel_invoice / substitute_invoice) frees each
// allocation back to its transaction as unallocated credit on the reservation.
//
// Throws if a payment can't be removed safely, so callers can abort BEFORE
// stamping anything irreversible.
export async function detachInvoicePayments(alegraInvoiceId) {
  if (!alegraInvoiceId) return 0;
  const detail = await alegraRequest(
    `invoices/${alegraInvoiceId}?fields=payments`,
    "GET"
  );
  let removed = 0;
  for (const p of detail?.payments || []) {
    const full = await alegraRequest(`payments/${p.id}`, "GET");
    // A stamped payment is a complemento de pago (REP). SAT requires cancelling
    // the REP BEFORE the PPD invoice, and a stamped REP can't be deleted — it
    // must be voided (motivo 02).
    if (full?.stamp?.uuid) {
      await alegraRequest(`payments/${p.id}/void`, "POST", { cause: "02" });
      removed++;
      continue;
    }
    // Unstamped payment (PUE / plain registration): a single Alegra payment can
    // span several invoices, so deleting it would unpay the others — only
    // auto-remove payments dedicated to this invoice.
    if ((full?.invoices || []).length > 1) {
      throw new Error(
        `El pago ${p.id} está aplicado a varias facturas. ` +
          `Quítalo de esta factura en Alegra antes de cancelar.`
      );
    }
    await alegraRequest(`payments/${p.id}`, "DELETE");
    removed++;
  }
  return removed;
}

// ---------- Contact (Alegra client) lookup / create ----------

export async function findOrCreateContact(billing) {
  // Público en General: always use dedicated contact id=1
  if (billing.rfc === "XAXX010101000") return "1";

  // Try to find by RFC. encodeURIComponent is required: RFCs can contain "&"
  // (common in moral-person RFCs like "C&I060223EY2"), which would otherwise
  // be parsed as a query-param separator, silently dropping the filter so
  // Alegra returns ALL contacts and we'd match the wrong taxpayer.
  try {
    const contacts = await alegraRequest(
      `contacts?identification=${encodeURIComponent(billing.rfc)}`,
      "GET"
    );
    if (Array.isArray(contacts) && contacts.length > 0) {
      // Never trust contacts[0] blindly: verify the RFC actually matches, in
      // case the filter was ignored or returned near-misses.
      const match = contacts.find(
        (c) => (c.identification || "").toUpperCase() === billing.rfc.toUpperCase()
      );
      if (match) return match.id;
    }
  } catch {}

  // Create new contact
  const contactRegime = getAlegraRegime(billing.regimenFiscal, billing.rfc);
  const contact = await alegraRequest("contacts", "POST", {
    name: billing.razonSocial,
    identification: billing.rfc,
    type: ["client"],
    thirdType: "NATIONAL",
    // Alegra's CFDI validation requires the `regime` string; `regimeObject`
    // alone is rejected with code 2141 "El régimen es obligatorio cuando se
    // tiene activo facturación electrónica", so no contact gets created.
    regime: contactRegime,
    regimeObject: [contactRegime],
    cfdiUse: billing.cfdiUse,
    paymentType: billing.paymentType,
    paymentMethod: billing.paymentForm,
    address: {
      zipCode: billing.codigoPostal,
      country: "MEX",
    },
  });

  return contact.id;
}

// Persist the chosen billing preferences back onto the customer/company so
// they prefill next time. Accepts either an id or the full entity.
export async function saveBillingSettings(billing, { customerId, companyId, alegraContactId }) {
  const updates = {
    regimen_fiscal: billing.regimenFiscal,
    codigo_postal_fiscal: billing.codigoPostal,
    alegra_contact_id: alegraContactId != null ? String(alegraContactId) : undefined,
    cfdi_use: billing.cfdiUse,
    payment_form: billing.paymentForm,
    payment_type_cfdi: billing.paymentType,
  };
  // Drop undefined keys
  Object.keys(updates).forEach((k) => updates[k] === undefined && delete updates[k]);

  if (companyId) {
    await supabase.from("companies").update(updates).eq("id", companyId);
  } else if (customerId) {
    await supabase.from("customers").update(updates).eq("id", customerId);
  }
}

// ---------- Build Alegra line items ----------
//
// `items` shape (per item):
//   { description, quantity, unitPrice, discount,
//     alegraItemId?, preResolvedUnit?, linePrefix?, isRental? }
//
// Returns an array of Alegra-formatted line objects ready to POST.
// Side effect: may create Alegra items if a line has no alegraItemId and
// no search match. Caches sublease item id on window to avoid re-creating.

export async function buildAlegraItems(items, { periodFrom, periodTo, invoiceNotes } = {}) {
  const alegraItems = [];
  const carItemCache = new Map(); // reservationId -> Alegra item id
  for (const item of items) {
    if (!item.description || !item.unitPrice) continue;

    let alegraItemId = item.alegraItemId || null;

    // Unit codes: DAY for rent, the picked product's own unit for manual concepts,
    // HUR for hours extra, E48 (servicio) for fees/adjustments.
    let unitCode = "E48";
    const serviceItemIds = [270, 271, 272, 273, ...Object.values(CHARGE_TYPE_ALEGRA)];
    if (item.isRental) unitCode = "DAY";
    else if (item.preResolvedUnit) unitCode = item.preResolvedUnit;
    else if (Number(item.alegraItemId) === 271) unitCode = "HUR";
    else if (!item.manual && item.alegraItemId && !serviceItemIds.includes(Number(item.alegraItemId))) unitCode = "DAY";

    let foundUnit = item.preResolvedUnit || null;
    if (!alegraItemId) {
      // Never create products from an invoice line (see "Alegra product resolution").
      if (item.isRental && item.isSublease) {
        alegraItemId = SUBLEASE_RENT_ALEGRA_ITEM_ID;
      } else if (item.isRental && item.reservationId) {
        if (!carItemCache.has(item.reservationId)) {
          carItemCache.set(item.reservationId, await ensureCarAlegraItem(item.reservationId));
        }
        alegraItemId = carItemCache.get(item.reservationId);
      } else {
        throw new Error(
          `"${item.description}" no tiene producto de Alegra. Elige un producto existente; ya no se crean productos desde la factura.`
        );
      }
      foundUnit = foundUnit || unitCode;
    }

    const unitPrice = parseFloat(item.unitPrice) || 0;
    const discountAmount = parseFloat(item.discount) || 0;
    // Keep 6 decimals (matches Alegra's calculationScale) so price × qty × 1.16
    // round-trips back to the IVA-inclusive total without losing cents.
    const priceBeforeTax =
      Math.round((unitPrice / 1.16) * 1000000) / 1000000;

    // Build description: period only for rent (DAY) items, notes on all
    const descParts = [];
    if (item.linePrefix) descParts.push(item.linePrefix);
    if (periodFrom && periodTo && unitCode === "DAY") {
      // periodTo is the last BILLED day; the CFDI shows the return day (+1) so
      // consecutive periods share a boundary: 1→8, 8→15 = 14 days.
      descParts.push(`Periodo: ${periodFrom} al ${addDaysISO(periodTo, 1)}`);
    }
    if (invoiceNotes && invoiceNotes.trim()) descParts.push(invoiceNotes.trim());
    const lineDescription = descParts.length > 0 ? descParts.join(". ") : undefined;

    const alegraLine = {
      id: alegraItemId,
      price: priceBeforeTax,
      quantity: parseFloat(item.quantity) || 1,
      description: lineDescription,
      tax: [{ id: 2 }], // IVA 16%
      unit: foundUnit || unitCode,
      productKey: "78111808",
    };

    if (discountAmount > 0 && unitPrice > 0) {
      const discountPercent = Math.round((discountAmount / unitPrice) * 10000) / 100;
      alegraLine.discount = discountPercent;
    }

    alegraItems.push(alegraLine);
  }
  return alegraItems;
}

// ---------- Rounding adjustment ----------
//
// Make the CFDI's stamped total land EXACTLY on `expectedTotal` (the agreed
// price) by adding — or shaving — an "Ajuste por redondeo" line. Mutates the
// array in place and returns it.
//
// The key is predicting Alegra's total the way Alegra actually computes it.
// Alegra uses `calculationTotalMethod = TOTALS_ROUNDED_BY_COMPANY_PRECISION`
// with `decimalPrecision = 2`: lines are kept at full precision, then the
// SUMMED (discounted) base and the SUMMED tax are EACH rounded to 2 decimals
// once and added — NOT a per-line `round(price×qty×1.16)`. Verified to the cent
// against live stamped invoices and against draft invoices for reservation 671.
// (Predicting per-line instead drifts a cent on multi-line invoices.)

// Predict Alegra's stamped total for a set of lines, exactly.
export function predictAlegraTotal(alegraItems) {
  let netBase = 0;
  for (const line of alegraItems) {
    const base = (line.price || 0) * (line.quantity || 1);
    const discounted = line.discount ? base * (1 - line.discount / 100) : base;
    netBase += discounted;
  }
  const subtotal = Math.round(netBase * 100) / 100;
  const tax = Math.round(netBase * 0.16 * 100) / 100;
  return Math.round((subtotal + tax) * 100) / 100;
}

export function applyRoundingAdjustment(alegraItems, expectedTotal) {
  const diff = Math.round((expectedTotal - predictAlegraTotal(alegraItems)) * 100) / 100;
  if (Math.abs(diff) < 0.005) return alegraItems;

  if (diff > 0) {
    // Add a positive "Ajuste por redondeo" line for the gross shortfall.
    const adj = {
      id: 273, // "Ajuste por redondeo" item in Alegra
      price: Math.round((diff / 1.16) * 1000000) / 1000000,
      quantity: 1,
      description: "Ajuste por redondeo",
      tax: [{ id: 2 }],
      unit: "E48",
      productKey: "84111506",
    };
    alegraItems.push(adj);
    // A rounding boundary can still leave ±1¢; nudge the adjustment line's
    // price until the predicted total matches exactly (converges in 1-2 steps).
    for (let i = 0; i < 5; i++) {
      const resid = Math.round((expectedTotal - predictAlegraTotal(alegraItems)) * 100) / 100;
      if (Math.abs(resid) < 0.005) break;
      adj.price = Math.round((adj.price + resid / 1.16) * 1000000) / 1000000;
    }
  } else {
    // Negative diff: a positive-importe line can't be negative, so shave the
    // last real line's unit price (spread over its quantity) to bring the total
    // down, then converge the same way.
    const lastItem = alegraItems[alegraItems.length - 1];
    for (let i = 0; i < 5; i++) {
      const resid = Math.round((expectedTotal - predictAlegraTotal(alegraItems)) * 100) / 100;
      if (Math.abs(resid) < 0.005) break;
      lastItem.price =
        Math.round(
          (lastItem.price + resid / 1.16 / (lastItem.quantity || 1)) * 1000000
        ) / 1000000;
    }
  }
  return alegraItems;
}

// ---------- Final invoice payload ----------

export function buildInvoicePayload({ billing, alegraItems, contactId, stamp }) {
  const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD local
  const alegraRegime =
    billing.rfc === "XAXX010101000"
      ? "SIMPLIFIED_REGIME"
      : getAlegraRegime(billing.regimenFiscal, billing.rfc);
  // PPD invoices carry a credit term: Alegra has no "credit days" field, so the
  // term is the gap between date and dueDate. PUE ⇒ due immediately.
  const creditDays =
    billing.paymentType === "PPD" ? parseInt(billing.creditDays, 10) || 0 : 0;
  const dueDate = creditDays > 0 ? addDaysISO(today, creditDays) : today;
  const payload = {
    date: today,
    dueDate,
    client: { id: String(contactId) },
    items: alegraItems,
    paymentMethod: billing.paymentForm,
    paymentType: billing.paymentType,
    cfdiUse: billing.cfdiUse,
    regimeClient: alegraRegime,
  };
  if (stamp) {
    payload.stamp = { generateStamp: true, version: "4.0" };
  }
  return { payload, today };
}

// ---------- Read-side: invoices that belong to a reservation ----------
//
// A reservation can be referenced either directly (invoices_issued.reservation_id)
// OR through an invoice_reservations join row (when one CFDI covers several
// reservations). This helper returns the unified list with a
// `reservation_portion` field — the IVA-included total belonging to this
// reservation, net of notas de crédito (useful for showing per-reservation balance on the detail page).

// A portion of an invoice, scaled down by the share its credit notes took off.
function netOfCredits(inv, portion) {
  const total = inv.total || 0;
  if (!(total > 0) || !(inv.amount_credited > 0)) return portion;
  return Math.round(portion * ((total - inv.amount_credited) / total) * 100) / 100;
}

export async function getInvoicesForReservation(reservationId) {
  // Exclude void/cancelled invoices — callers use this to compute "already
  // invoiced" sums; a voided invoice should not block re-invoicing.
  const [direct, joined] = await Promise.all([
    supabase
      .from("invoices_issued")
      .select("*")
      .eq("reservation_id", reservationId)
      .neq("status", "void"),
    supabase
      .from("invoice_reservations")
      .select("invoice_id, quantity, unit_price, discount, period_from, period_to")
      .eq("reservation_id", reservationId),
  ]);

  const byId = new Map();
  for (const row of direct.data || []) {
    // Directly-linked invoices: the reservation owns the full total, net of
    // notas de crédito (they lowered what was really billed).
    byId.set(row.id, { ...row, reservation_portion: netOfCredits(row, row.total) });
  }

  // Collect unique invoice ids from the join rows not already fetched.
  const joinIds = [
    ...new Set((joined.data || []).map((j) => j.invoice_id)),
  ].filter((id) => !byId.has(id));

  let extraInvoices = [];
  if (joinIds.length > 0) {
    const { data } = await supabase
      .from("invoices_issued")
      .select("*")
      .in("id", joinIds)
      .neq("status", "void");
    extraInvoices = data || [];
  }

  // Compute per-reservation portion for join-based invoices.
  const portions = new Map();
  for (const j of joined.data || []) {
    const lineGross = (j.quantity || 0) * (j.unit_price || 0);
    const lineDisc = (j.quantity || 0) * (j.discount || 0);
    portions.set(
      j.invoice_id,
      (portions.get(j.invoice_id) || 0) + (lineGross - lineDisc)
    );
  }
  // Multi-reservation invoices carry no period on the invoice row; each line in
  // invoice_reservations has this reservation's own span (inclusive period_to).
  const joinPeriods = new Map();
  for (const j of joined.data || []) {
    if (!j.period_from) continue;
    const list = joinPeriods.get(j.invoice_id) || [];
    list.push({ period_from: j.period_from, period_to: j.period_to || j.period_from });
    joinPeriods.set(j.invoice_id, list);
  }
  for (const row of extraInvoices) {
    const resPeriods = joinPeriods.get(row.id) || [];
    const span =
      resPeriods.length > 0 && !row.period_from
        ? {
            // Overall span, for single-period consumers (e.g. the rate-change
            // guard in Reservation.js). Gap checks use reservation_periods.
            period_from: resPeriods.map((p) => p.period_from).sort()[0],
            period_to: resPeriods.map((p) => p.period_to).sort().slice(-1)[0],
          }
        : {};
    byId.set(row.id, {
      ...row,
      ...span,
      reservation_portion: netOfCredits(row, portions.get(row.id) || 0),
      reservation_periods: resPeriods,
    });
  }

  // Sort newest-first for UI consistency.
  return Array.from(byId.values()).sort((a, b) => {
    const da = new Date(a.date || 0);
    const db = new Date(b.date || 0);
    return db - da;
  });
}

// Return period objects `{ period_from, period_to }` for all non-void invoices
// that cover a reservation — used by period-overlap checks. Includes both
// directly-linked invoices and those tied via invoice_reservations.

export async function getInvoicedPeriodsForReservation(reservationId) {
  return billedPeriodsFromInvoices(await getInvoicesForReservation(reservationId));
}

// Billed rent periods for ONE reservation, from getInvoicesForReservation's list.
// Multi-reservation invoices contribute each of this reservation's own line
// periods (not the overall span, which could hide a gap between lines);
// single-reservation invoices contribute their own period; fee-only invoices
// (no period) contribute nothing.
export function billedPeriodsFromInvoices(invoices = []) {
  const out = [];
  for (const inv of invoices || []) {
    if (inv?.reservation_periods?.length) {
      for (const p of inv.reservation_periods) {
        out.push({ ...inv, period_from: p.period_from, period_to: p.period_to });
      }
    } else if (inv?.period_from) {
      out.push(inv);
    }
  }
  return out;
}

// Determine which concepts a reservation has ALREADY been invoiced for, so the
// invoice builders propose only what's still missing (instead of re-billing rent
// + fees, or — the opposite bug — silently dropping a fee that was left off the
// first invoice).
//
// Three dedup signals:
//   • Rent  → by PERIOD (period_from/period_to on prior non-void invoices).
//   • Fees / hours → by their Alegra PRODUCT id (270 recolección, 272 entrega,
//     271 horas), read from the prior invoices' line items. These are
//     one-per-reservation concepts, so "product id already on an invoice" is
//     exactly the right test.
//   • Extra charges → by the charge ROW, via reservation_charges.billed_invoice_id.
//     NOT by product id: all charges of a type share one product (all fuel
//     charges are 276), so the product-id rule marked every charge after the
//     first of its type as billed and silently dropped it from the proposal —
//     unbillable from the UI while still in the reservation balance.
//
// Returns:
//   periods        – [{ period_from, period_to, invoice_number, id }] (non-void, with a period)
//   billedItemIds  – Set<number> of Alegra product ids already invoiced
//   billedChargeIds– Set<number> of reservation_charges ids already invoiced
//   alegraReadOk   – false if any prior invoice's items could not be read (no
//                    alegra_id, or the Alegra fetch failed). Callers should then
//                    fall back to a conservative "billed if a prior invoice
//                    exists" rule so a transient read failure never double-bills.
//                    Charges are unaffected: their link is in our own DB.
export async function getInvoicedConceptsForReservation(reservationId, exceptInvoiceId = null) {
  const invoices = await getInvoicesForReservation(reservationId);
  const periods = billedPeriodsFromInvoices(invoices);
  const billedChargeIds = await getBilledChargeIds(reservationId, exceptInvoiceId);
  const billedItemIds = new Set();
  let alegraReadOk = true;

  for (const inv of invoices) {
    if (!inv.alegra_id) {
      // Draft/unstamped invoice with no Alegra document — its lines are unknown.
      alegraReadOk = false;
      continue;
    }
    try {
      const data = await alegraRequest(`invoices/${inv.alegra_id}`, "GET");
      for (const it of data?.items || []) {
        if (it?.id != null) billedItemIds.add(Number(it.id));
      }
    } catch {
      alegraReadOk = false;
    }
  }

  // A fee concept is already billed when its product id is on a prior invoice;
  // when we couldn't read the lines, fall back to "any prior invoice exists" so
  // we never re-bill.
  const isConceptBilled = (alegraItemId) =>
    alegraReadOk ? billedItemIds.has(Number(alegraItemId)) : invoices.length > 0;

  const isChargeBilled = (chargeId) => billedChargeIds.has(Number(chargeId));

  return {
    invoices,
    periods,
    billedItemIds,
    billedChargeIds,
    alegraReadOk,
    isConceptBilled,
    isChargeBilled,
  };
}

// Ids of a reservation's extra charges that a LIVE invoice already billed.
//
// The link is reservation_charges.billed_invoice_id, but a charge only counts
// as billed while its invoice is alive: voiding a CFDI has to put its charges
// back on the table, exactly as it does for rent periods. So the invoice status
// is re-checked here rather than clearing the column on cancellation — one
// writer, no second state to keep in sync.
//
// `exceptInvoiceId` is the substitution case: the invoice being replaced is
// still un-voided while the replacement is being built, but its charges belong
// on the new CFDI, so it doesn't count as billing them.
export async function getBilledChargeIds(reservationId, exceptInvoiceId = null) {
  const { data, error } = await supabase
    .from("reservation_charges")
    .select("id, billed_invoice_id")
    .eq("reservation_id", reservationId)
    .not("billed_invoice_id", "is", null);
  if (error || !data?.length) return new Set();

  const rows = exceptInvoiceId
    ? data.filter((c) => Number(c.billed_invoice_id) !== Number(exceptInvoiceId))
    : data;
  if (rows.length === 0) return new Set();

  const invoiceIds = [...new Set(rows.map((c) => c.billed_invoice_id))];
  const { data: live } = await supabase
    .from("invoices_issued")
    .select("id")
    .in("id", invoiceIds)
    .neq("status", "void");
  const liveIds = new Set((live || []).map((i) => i.id));

  return new Set(
    rows.filter((c) => liveIds.has(c.billed_invoice_id)).map((c) => Number(c.id))
  );
}

// Link the charges a freshly-created invoice actually billed, so they aren't
// proposed again. Non-fatal: the CFDI is already stamped by the time this runs,
// and a charge that fails to link just shows up again in the next invoice's
// proposal (where it can be unticked) rather than being lost.
export async function markChargesBilled(chargeIds, invoiceId) {
  const ids = [...new Set((chargeIds || []).map(Number).filter(Boolean))];
  if (ids.length === 0 || !invoiceId) return;
  const { error } = await supabase
    .from("reservation_charges")
    .update({ billed_invoice_id: invoiceId })
    .in("id", ids);
  if (error) console.error("markChargesBilled failed:", error);
}

// ---------- Section-aware rent lines ----------
//
// A reservation's daily rate is a piecewise-constant function over time, stored
// as rows in `reservation_price_periods`. When invoicing a billing slice
// [periodFrom, periodTo] we emit one rent line per section overlap so the CFDI
// shows exactly what was charged for each rate. Single-section reservations
// (the overwhelming common case) still produce a single rent line.

function isoDate(d) {
  return d instanceof Date ? d.toISOString().substring(0, 10) : String(d).substring(0, 10);
}
export function addDaysISO(iso, n) {
  const d = new Date(iso);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().substring(0, 10);
}
function maxISO(a, b) { return a > b ? a : b; }
function minISO(a, b) { return a < b ? a : b; }
function daysBetweenExclusive(fromInclusive, toExclusive) {
  return Math.max(
    0,
    Math.round((new Date(toExclusive) - new Date(fromInclusive)) / 86400000)
  );
}
const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// Last billable day (inclusive) of a reservation's date_range, applying the
// same >5h-leftover rounding rule the UI uses in getReservationTime — so the
// invoice flow agrees with rent_time.days and compute_reservation_total_rent.
//
// Why this exists: upper(date_range)::date is one day past the last billable
// day. buildRentLines treats periodTo as INCLUSIVE (it adds +1 to derive the
// exclusive end), so passing the raw upper date over-counts by exactly 1 day.
export function reservationLastBillableDay(rangeStr) {
  if (!rangeStr) return "";
  const clean = String(rangeStr).replace(/[\[\]()]/g, "");
  const parts = clean.split(",");
  const lowerStr = parts[0]?.replace(/"/g, "").trim();
  const upperStr = parts[1]?.replace(/"/g, "").trim();
  if (!lowerStr || !upperStr) return "";
  const lower = new Date(lowerStr);
  const upper = new Date(upperStr);
  const totalSec = (upper - lower) / 1000;
  if (!Number.isFinite(totalSec) || totalSec <= 0) return lowerStr.substring(0, 10);
  let fullDays = Math.floor(totalSec / 86400);
  const extraSec = totalSec - fullDays * 86400;
  if (extraSec > 5 * 3600) fullDays += 1;
  if (fullDays < 1) fullDays = 1;
  return addDaysISO(lowerStr.substring(0, 10), fullDays - 1);
}

// Which stretches of a reservation's billable span still have no invoice on
// them. `fullFrom` / `fullTo` are both INCLUSIVE (fullTo = last billable day,
// i.e. reservationLastBillableDay), as are each billed period's
// period_from / period_to. Returns the gaps in chronological order.
//
// Why this is not just "the day after the latest period_to": invoiced periods
// are NOT guaranteed to form a prefix of the reservation. A reservation can be
// billed out of order — res 1134 had only 01-ago invoiced while 31-jul (its
// FIRST day) was never billed — and the old max(period_to) rule declared the
// rent fully invoiced and blanked the period, leaving that earlier day
// unreachable from the UI. Walking the whole span finds gaps wherever they are.
export function computeUninvoicedGaps(fullFrom, fullTo, billedPeriods = []) {
  if (!fullFrom || !fullTo) return [];
  const start = isoDate(fullFrom);
  const end = isoDate(fullTo);
  if (start > end) return [];

  const billed = (billedPeriods || [])
    .filter((p) => p && p.period_from)
    .map((p) => ({
      from: isoDate(p.period_from),
      to: isoDate(p.period_to || p.period_from),
    }))
    .sort((a, b) => (a.from < b.from ? -1 : a.from > b.from ? 1 : 0));

  const gaps = [];
  let cursor = start;
  for (const b of billed) {
    if (b.to < cursor) continue; // already behind the cursor (or overlapping earlier billing)
    if (b.from > end) break; // beyond the reservation
    if (b.from > cursor) {
      gaps.push({ from: cursor, to: minISO(addDaysISO(b.from, -1), end) });
    }
    const next = addDaysISO(b.to, 1);
    if (next > cursor) cursor = next;
    if (cursor > end) break;
  }
  if (cursor <= end) gaps.push({ from: cursor, to: end });

  return gaps.filter((g) => g.from <= g.to);
}

// True when [from, to] (inclusive) touches any already-invoiced period. Returns
// the clashing period so callers can name it in the error.
export function findPeriodOverlap(from, to, billedPeriods = []) {
  if (!from || !to) return null;
  const f = isoDate(from);
  const t = isoDate(to);
  return (
    (billedPeriods || []).find((p) => {
      if (!p || !p.period_from) return false;
      const pFrom = isoDate(p.period_from);
      const pTo = isoDate(p.period_to || p.period_from);
      return f <= pTo && t >= pFrom;
    }) || null
  );
}

// Sublease cars have no Alegra item to carry vehicle data (all subleases reuse
// one shared "Renta de vehículo" item), so the vehicle details must live in the
// per-line description. Mirrors the (Marca)(Modelo)(Placa) shape that owned cars
// get from their own Alegra item. Includes only the fields that are present.
export function buildSubleaseVehicleLabel({ plate, brand, model } = {}) {
  const parts = [];
  if (brand) parts.push(`(Marca: ${brand})`);
  if (model) parts.push(`(Modelo: ${model})`);
  if (plate) parts.push(`(Placa: ${plate})`);
  const head = plate ? `Renta de vehículo ${plate}` : "Renta de vehículo";
  return parts.length ? `${head} ${parts.join(" ")}` : head;
}

export async function buildRentLines(
  reservationId,
  periodFrom,
  periodTo,
  { plate, alegraItemId, isSublease, subleaseBrand, subleaseModel } = {}
) {
  const { data: sections } = await supabase
    .from("reservation_price_periods")
    .select("daily_price, effective_from, effective_to, billable_amount")
    .eq("reservation_id", reservationId)
    .order("effective_from");

  if (!sections || sections.length === 0) return [];

  const pFrom = isoDate(periodFrom);
  const pToExclusive = addDaysISO(isoDate(periodTo), 1); // periodTo is inclusive; convert to exclusive for half-open math

  const lines = [];
  for (const s of sections) {
    // Section bounds, also as inclusive→exclusive on the right.
    const secFromInc = isoDate(s.effective_from);
    const secToExclusive = s.effective_to
      ? addDaysISO(isoDate(s.effective_to), 1)
      : pToExclusive;
    const from = maxISO(secFromInc, pFrom);
    const toExcl = minISO(secToExclusive, pToExclusive);
    const days = daysBetweenExclusive(from, toExcl);
    if (days <= 0) continue;

    const toInc = addDaysISO(toExcl, -1);
    // Label ends on the return day (exclusive) so 7 days reads "1 al 8" and the
    // next period starts on that same day. sectionPeriodTo stays inclusive.
    const periodLabel = `Periodo ${from} al ${toExcl}`;
    const baseDesc = isSublease
      ? "Renta de vehículo"
      : `Renta de vehículo${plate ? ` ${plate}` : ""}`;

    lines.push({
      reservationId,
      description: `${baseDesc} - ${periodLabel}`,
      quantity: days,
      unitPrice: s.daily_price,
      discount: 0,
      // Exact intended gross (IVA-incl) for this line, BEFORE the per-unit
      // discount is rounded to 2 decimals for the CFDI. The invoice flow sums
      // these to get the true target total (and the rounding adjustment bridges
      // Alegra's computed total to it). Overwritten below when a discount ratio
      // applies. See applyRoundingAdjustment.
      intendedTotal: s.daily_price * days,
      alegraItemId: isSublease ? SUBLEASE_RENT_ALEGRA_ITEM_ID : alegraItemId,
      isSublease: !!isSublease,
      linePrefix: isSublease
        ? buildSubleaseVehicleLabel({ plate, brand: subleaseBrand, model: subleaseModel })
        : null,
      isRental: true,
      sectionPeriodFrom: from,
      sectionPeriodTo: toInc,
    });
  }

  // Rent is billed at the FULL daily_price. Discounts are NOT applied here — they
  // are applied MANUALLY per invoice in the invoice UI, where the user sees the
  // reservation's available discount (getReservationDiscountSummary) and either
  // drops whole days (reduce the rent quantity) or enters a per-line discount.
  // The amount actually discounted is measured (full vs billed) and recorded on
  // the invoice at save time. This replaces the old back-solve from total_price
  // vs computed rent, which drifted and fabricated discounts (res 379 / 774).
  return { lines, discountApplied: 0, discountDays: 0 };
}

// Apply a user-chosen discount to the FULL-price lines of ONE reservation on ONE
// invoice: drop `days` whole days (quantity reduction on RENT lines only, latest
// section first) and/or spread `amount` pesos (IVA-incl) as a per-unit CFDI
// discount. The money portion lands on rent first and SPILLS OVER to the
// reservation's other concepts (fees, cargos like gasolina) when rent can't
// absorb it — a reservation whose rent was already invoiced still has to be able
// to discount its remaining charges (res 711: $1,190 de gasolina con $760 de
// descuento, invoice with no rent line at all). Callers should therefore pass
// ALL of the reservation's lines, not just the rent ones. Returns adjusted lines
// (zero-day rent lines removed) plus what was actually removed, for persisting
// on the invoice (discount_applied / discount_days). Pure — no DB, safe to call
// from render.
export function applyInvoiceDiscount(invoiceLines, { days = 0, amount = 0 } = {}) {
  const lines = (invoiceLines || []).map((l) => ({
    ...l,
    discount: 0,
    intendedTotal: (Number(l.unitPrice) || 0) * (Number(l.quantity) || 0),
  }));
  let discountDays = 0; //    whole days dropped
  let discountApplied = 0; // MONEY-only pesos discounted (excludes day-drop value)
  let remainingDays = Math.max(0, Math.floor(Number(days) || 0));

  for (let i = lines.length - 1; i >= 0 && remainingDays > 0; i--) {
    if (!lines[i].isRental) continue; // days are a rent-only concept
    const drop = Math.min(remainingDays, Number(lines[i].quantity) || 0);
    if (drop <= 0) continue;
    lines[i].quantity = (Number(lines[i].quantity) || 0) - drop;
    lines[i].intendedTotal =
      (Number(lines[i].unitPrice) || 0) * lines[i].quantity;
    discountDays += drop;
    remainingDays -= drop;
  }

  const money = Math.max(0, round2(Number(amount) || 0));
  let leftToDiscount = money;
  // Rent absorbs the discount first; whatever it can't cover spreads over the
  // remaining concepts, each group at its own ratio.
  const billable = lines.filter((l) => (Number(l.quantity) || 0) > 0);
  for (const group of [
    billable.filter((l) => l.isRental),
    billable.filter((l) => !l.isRental),
  ]) {
    if (leftToDiscount <= 0.005 || group.length === 0) continue;
    const gross = group.reduce(
      (s, l) => s + (Number(l.unitPrice) || 0) * (Number(l.quantity) || 0),
      0
    );
    if (gross <= 0) continue;
    const ratio = Math.min(1, leftToDiscount / gross);
    for (const line of group) {
      const up = Number(line.unitPrice) || 0;
      line.discount = round2(up * ratio);
      line.intendedTotal = up * (Number(line.quantity) || 0) * (1 - ratio);
    }
    leftToDiscount = round2(Math.max(0, leftToDiscount - gross * ratio));
  }
  discountApplied = round2(money - leftToDiscount);

  return {
    // Only RENT lines vanish when fully discounted (all their days dropped);
    // fee/manual lines are kept so the editor doesn't lose rows mid-edit.
    lines: lines.filter((l) => !l.isRental || (Number(l.quantity) || 0) > 0),
    discountApplied, // money portion only (days tracked separately)
    discountDays,
  };
}

// Discount a reservation has available to apply on the invoice being built:
// everything recorded in reservation_discounts (frozen at creation) minus what
// prior non-void invoices already recorded as consumed. Used by the invoice UI
// to show "Descuento disponible: N días / $X" and to warn if more is applied
// than remains.
export async function getReservationDiscountSummary(reservationId) {
  const [{ data: rows }, prior] = await Promise.all([
    supabase
      .from("reservation_discounts")
      .select("amount, days, daily_price")
      .eq("reservation_id", reservationId),
    getInvoicesForReservation(reservationId),
  ]);
  // Recorded discounts split by kind: whole-day (days set) vs money-only (days
  // null). Days are consumed via day-drops (tracked in invoices.discount_days);
  // money-only via a per-unit discount (tracked in invoices.discount_applied).
  const totalDays = (rows || []).reduce((s, d) => s + (Number(d.days) || 0), 0);
  const totalMoney = (rows || []).reduce(
    (s, d) => s + (d.days == null ? Number(d.amount) || 0 : 0),
    0
  );
  const dayRate = (rows || []).find((d) => d.days != null)?.daily_price || 0;
  const appliedDays = prior.reduce((s, i) => s + (Number(i.discount_days) || 0), 0);
  const appliedMoney = prior.reduce((s, i) => s + (Number(i.discount_applied) || 0), 0);
  return {
    totalDays,
    totalMoney: round2(totalMoney),
    appliedDays,
    appliedMoney: round2(appliedMoney),
    remainingDays: Math.max(0, totalDays - appliedDays),
    remainingMoney: Math.max(0, round2(totalMoney - appliedMoney)),
    dailyPrice: dayRate,
  };
}

// ---------- Prefill billing defaults from a customer/company entity ----------

export function prefillBillingFromEntity(entity, isCompany) {
  const rfc = (entity && entity.rfc) || "XAXX010101000";
  const isGeneric = rfc === "XAXX010101000";
  const billing = {
    rfc,
    razonSocial: isGeneric
      ? "Público en General"
      : isCompany
      ? entity.name || ""
      : entity.razon_social ||
        `${entity.first_name || ""} ${entity.last_name || ""}`.trim(),
    regimenFiscal: isGeneric ? "616" : entity.regimen_fiscal || "616",
    codigoPostal: entity.codigo_postal_fiscal || entity.rfc_pc || "",
    cfdiUse: isGeneric ? "S01" : entity.cfdi_use || "G03",
    paymentForm: entity.payment_form || "transfer",
    paymentType: entity.payment_type_cfdi || "PUE",
    // Días de crédito for PPD invoices (companies only). Drives the Alegra
    // dueDate; overridable per invoice in the UI. Empty/0 ⇒ due immediately.
    creditDays: entity.credit_days ?? "",
  };
  const emailTo = entity.email || entity.contact_email || "";
  return { billing, emailTo };
}

// ---------- Público en General override ----------
//
// Occasionally a client that HAS fiscal data on file still wants the sale
// stamped to the generic RFC (mostrador / no quiere factura a su nombre).
// This swaps only the receptor block; the payment fields the operator already
// set (forma de pago) survive. It is a per-invoice override: callers MUST skip
// saveBillingSettings while it's active, otherwise the client's real régimen,
// uso de CFDI and alegra_contact_id get overwritten with the generic ones
// (findOrCreateContact returns contact id "1" for this RFC).
//
// Método de pago is forced to PUE: a generic receptor can never receive a
// complemento de pago, so a PPD CFDI to XAXX010101000 could never be settled.

export const GENERIC_RFC = "XAXX010101000";

export const isPublicoGeneral = (billing) =>
  (billing?.rfc || "").toUpperCase() === GENERIC_RFC;

export function publicoGeneralBilling(billing) {
  return {
    ...billing,
    rfc: GENERIC_RFC,
    razonSocial: "Público en General",
    regimenFiscal: "616",
    // Not transmitted (Alegra takes the domicilio from contact id 1), but
    // showing the client's real CP next to "Público en General" is misleading.
    codigoPostal: "",
    cfdiUse: "S01",
    paymentType: "PUE",
    creditDays: "",
  };
}
